export const MANAGE_ITEM_IDS = [
  // TODOS
  'photos-todo',
  'host-services-todo',
  'setup-check-in',

  // LISTING PAGE
  'pool-details',
  'amenities',
  'title-and-description',
  'photos',
  'video-tour',
  'restroom',
  'privacy',

  // PRICING
  'pricing',
  'promotions',
  'security-deposit',
  'memberships',
  'pool-passes',
  'host-services',
  'additional-spaces-access',

  // POLICIES
  'host-rules',
  'guest-settings',
  'booking-restrictions',
  'cancellation-policy',
  'instant-booking-settings',

  // CHECK-IN
  'parking',
  'access-instructions',
  'automated-messages',
  'branding-signage',

  // CALENDAR
  'availability',
  'discounts-surges',

  // Ported from V1
  'earnings',
  'grow',
] as const
export type ManageItemId = (typeof MANAGE_ITEM_IDS)[number]

export function isManageItemId(itemId?: string | null): itemId is ManageItemId {
  if (!itemId) return false
  return MANAGE_ITEM_IDS.includes(itemId as ManageItemId)
}

export enum CopyEntryKey {
  Title = 'manage_screen.title',
  MobileTitle = 'manage_screen.mobile-title',
  SearchPlaceholder = 'manage_screen.search-placeholder',
  BookabilityTitle = 'manage_screen.bookability-title',
  BookabilityDescription = 'manage_screen.bookability-description',

  // BOOST
  BoostTitleInProgress = 'manage_screen.boost-title-state-in-progress',
  BoostTitleReady = 'manage_screen.boost-title-state-ready',
  BoostTitleActive = 'manage_screen.boost-title-state-active',

  BoostSubtitleInProgress = 'manage_screen.boost-subtitle-in-progress',
  BoostSubtitleReady = 'manage_screen.boost-subtitle-ready',
  BoostSubtitleActive = 'manage_screen.boost-subtitle-active',

  BoostButtonInProgressPlural = 'manage_screen.boost-button-in-progress-plural',
  BoostButtonInProgressSingular = 'manage_screen.boost-button-in-progress-singular',
  BoostButtonReady = 'manage_screen.boost-button-ready',
  BoostButtonActivePlural = 'manage_screen.boost-button-active-plural',
  BoostButtonActiveSingular = 'manage_screen.boost-button-active-singular',
}

export enum BoostStatusEnum {
  NotAvailable = 'not_available',
  Available = 'available',
  InUse = 'in_use',
  Used = 'used',
}
